import axios from 'axios';
import common from '@/commons/common.js';
import { Message } from 'element-ui';
import languageType from '../../components/language';
window.app.axios = axios;
let http = axios.create({
    withCredentials: true,
    timeout: 1800000
});

function apiAxios(method, url, params, response, headers, hostName, responseType) {
    http({
        method: method,
        url: hostName === null || hostName === undefined ? window.config.host + url : hostName + url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        headers: headers !== undefined && headers != null ? headers : null,
        responseType: responseType === undefined ? '' : responseType
    })
        .then(function(res) {
            if (res === null || res === undefined) {
                return;
            }
            if (
                res.data.statusCode === common.requestCode.ERROR_PASSWORD &&
                res.config.url.indexOf('authCtrl/login') < 0 &&
                res.config.url.indexOf('/auth/authCtrl/changePassword') < 0 &&
                res.config.url.indexOf('/auth/authCtrl/haveAllPermission') < 0
            ) {
                Message.error(window.i18n.t('common.LOG_IN_AGAIN'));
                return;
            }
            response(res);
        })
        .catch(function(err) {
            if (err.message == "Cannot read property '_t' of null") {
                return;
            }
            // let data = {
            //     statusCode: 'API_ERROR',
            //     statusMessage: window.i18n.t('error.ERROR_API')
            // };
            if (err.response) {
                // err.response.data = data;
                response(err.response);
            } else {
                // err.data = data;
                response(err);
            }
        });
}

// 验证菜单及位置名称
function getMenuName(operationLocation) {
    if (operationLocation) {
        return operationLocation;
    }
    let titles = getMenu();
    if (titles) {
        let set = new Set(titles);
        titles = Array.from(set);
        if (titles.length >= 0) {
            return titles.join('-');
        }
    }
    return '';
}

// 验证类型是否匹配
function getMenu() {
    if (window.getCurrentMenu) {
        if (window.getCurrentMenu() != null) {
            return window.getCurrentMenu();
        }
    } else if (window.parent == window && parent.getCurrentMenu) {
        if (parent.getCurrentMenu() != null) {
            return parent.getCurrentMenu();
        }
    }
}

export default {
    get: function(url, params, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('GET', url, params, response, headers, hostName);
    },
    post: function(url, params, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('POST', url, params, response, headers, hostName);
    },
    postRequestBody: function(url, params, response, hostName, operationLocation, token) {
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('POST', url, params, response, headers, hostName);
    },
    put: function(url, params, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('PUT', url, params, response, headers, hostName);
    },
    delete: function(url, params, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('DELETE', url, params, response, headers, hostName);
    },
    download: function(url, params, responseType, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('GET', url, params, response, headers, hostName, responseType);
    },
    downloadPost: function(url, params, responseType, response, hostName, operationLocation, token) {
        let headers = {
            token: token ? token : sessionStorage.getItem('token'),
            operationLocation: encodeURI(encodeURI(getMenuName(operationLocation))),
            languageType: window.vue.$store.state.language
        };
        let t = '?t=' + new Date().getTime();
        if (/\?/g.test(url)) {
            t = '&t=' + new Date().getTime();
        }
        url = url + t;
        return apiAxios('POST', url, params, response, headers, hostName, responseType);
    },
    // 获取操作位置名称
    getoperationLocation(operationLocation) {
        return getMenuName(operationLocation);
    },
    axios(method, url, params, response, headers, hostName, responseType) {
        let languagecode = window.vue.$store.state.language;
        headers.assign(languageType, languagecode);
        return apiAxios(method, url, params, response, headers, hostName, responseType);
    }
};
